export default __webpack_public_path__ + "static/media/section3-step3.140c019a.png";